<template>
  <v-card height="100%" class="pa-4" rounded="lg">
    <h2 style="font-size: 20px;">Total Orders</h2>
    <h1 class="my-1">
      {{ totalOrders }}
    </h1>
    <div class="d-flex align-center justify-space-between">
      <label class="border--text font-weight-medium">
        Online store
      </label>
      <h3>
        {{ onlineStoreOrders }}
      </h3>
    </div>
    <div class="d-flex align-center justify-space-between mb-4">
      <label class="border--text">
        Total orders via Boost Upsell
      </label>
      <h3>
        {{ uselTotalOrders }}
      </h3>
    </div>
    <h3 class="mb-3 font-weight-medium">Order OVERTIME</h3>
    <LineChart v-if="isLoading" :chartdata="chartOrdersData" :options="chartOrdersOpts" :height="300" />
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import LineChart from '@/components/chart/Line';
import { FETCH_TOTAL_ORDERS } from '@/store/actions.type';
import STORAGE_NAME from '@/const/storage';

export default {
  props: {
    dateRange: {
      from: Date,
      to: Date,
    },
    stores: Array,
    timezone: String,
  },
  components: {
    LineChart,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  mounted: async function() {
    this.isLoading = true;
    let { startDate, endDate, stores } = this.loadQueryFromCache();

    let fromTime = startDate
      ? startDate
      : this.$props.dateRange && this.$props.dateRange.from
      ? moment(this.$props.dateRange.from).format('YYYY-MM-DD')
      : moment()
          .tz(this.timezone)
          .format('YYYY-MM-DD');
    let toTime = endDate
      ? endDate
      : this.$props.dateRange && this.$props.dateRange.to
      ? moment(this.$props.dateRange.to).format('YYYY-MM-DD')
      : moment()
          .tz(this.timezone)
          .format('YYYY-MM-DD');
    let _stores = stores ? stores : this.$props.stores ? this.$props.stores : '';
    await this.$store.dispatch(FETCH_TOTAL_ORDERS, { fromTime, toTime, stores: _stores, timezone: this.timezone });
    this.isLoading = true;
  },
  computed: {
    ...mapGetters(['chartOrdersData', 'chartOrdersOpts']),
    totalOrders() {
      return this.$store.getters.totalOrders;
    },
    uselTotalOrders() {
      return this.$store.getters.uselTotalOrders;
    },
    onlineStoreOrders() {
      return this.$store.getters.onlineStoreOrders;
    },
  },
  methods: {
    loadQueryFromCache() {
      let cacheQuery = localStorage.getItem(STORAGE_NAME.REPORT_SEARCH_QUERY);
      return cacheQuery ? JSON.parse(cacheQuery) : {};
    },
  },
  watch: {
    dateRange: async function(newTime, currTime) {
      let fromTime = newTime
        ? moment(newTime.from).format('YYYY-MM-DD')
        : moment()
            .tz(this.timezone)
            .format('YYYY-MM-DD');
      let toTime =
        newTime && newTime.to
          ? moment(newTime.to).format('YYYY-MM-DD')
          : moment()
              .tz(this.timezone)
              .format('YYYY-MM-DD');
      await this.$store.dispatch(FETCH_TOTAL_ORDERS, {
        fromTime,
        toTime,
        stores: this.stores,
        timezone: this.timezone,
      });
    },
    stores: async function(newStores, currStores) {
      let { startDate, endDate } = this.loadQueryFromCache();
      let fromTime = startDate
        ? startDate
        : this.$props.dateRange && this.$props.dateRange.from
        ? moment(this.$props.dateRange.from).format('YYYY-MM-DD')
        : moment()
            .tz(this.timezone)
            .format('YYYY-MM-DD');
      let toTime = endDate
        ? endDate
        : this.$props.dateRange && this.$props.dateRange.to
        ? moment(this.$props.dateRange.to).format('YYYY-MM-DD')
        : moment()
            .tz(this.timezone)
            .format('YYYY-MM-DD');
      await this.$store.dispatch(FETCH_TOTAL_ORDERS, { fromTime, toTime, stores: newStores, timezone: this.timezone });
    },
  },
};
</script>
